import { render, staticRenderFns } from "./BlockContactDetails.vue?vue&type=template&id=514c3da2&"
import script from "./BlockContactDetails.vue?vue&type=script&lang=js&"
export * from "./BlockContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports